/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_E2eInputs */

const en_svchip_e2e = /** @type {(inputs: Svchip_E2eInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E2E`)
};

const ar_svchip_e2e = /** @type {(inputs: Svchip_E2eInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الاختبار الشامل`)
};

const bn_svchip_e2e = /** @type {(inputs: Svchip_E2eInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E2E`)
};

const de_svchip_e2e = /** @type {(inputs: Svchip_E2eInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E2E`)
};

const es_svchip_e2e = /** @type {(inputs: Svchip_E2eInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E2E`)
};

const fr_svchip_e2e = /** @type {(inputs: Svchip_E2eInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E2E`)
};

const pt_svchip_e2e = /** @type {(inputs: Svchip_E2eInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E2E`)
};

const zh_svchip_e2e = /** @type {(inputs: Svchip_E2eInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E2E`)
};

const tr_svchip_e2e = /** @type {(inputs: Svchip_E2eInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E2E`)
};

const ru_svchip_e2e = /** @type {(inputs: Svchip_E2eInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E2E`)
};

const pl_svchip_e2e = /** @type {(inputs: Svchip_E2eInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E2E`)
};

/**
* | output |
* | --- |
* | "E2E" |
*
* @param {Svchip_E2eInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_e2e = /** @type {((inputs?: Svchip_E2eInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_E2eInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_e2e(inputs)
	if (locale === "bn") return bn_svchip_e2e(inputs)
	if (locale === "de") return de_svchip_e2e(inputs)
	if (locale === "es") return es_svchip_e2e(inputs)
	if (locale === "fr") return fr_svchip_e2e(inputs)
	if (locale === "pt") return pt_svchip_e2e(inputs)
	if (locale === "zh") return zh_svchip_e2e(inputs)
	if (locale === "tr") return tr_svchip_e2e(inputs)
	if (locale === "ru") return ru_svchip_e2e(inputs)
	if (locale === "pl") return pl_svchip_e2e(inputs)
	return en_svchip_e2e(inputs)
});